module.exports = __webpack_public_path__ + "static/media/winding-forest-road.c7061ee5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/winding-forest-road.mp4
// module id = 1700
// module chunks = 0